export default "__VITE_ASSET__NXEpWGOZ__"